// extracted by mini-css-extract-plugin
export default {"breadcrumbs_wrapper":"breadcrumbs_breadcrumbs_wrapper__17rYv"};